export const VIEW_SEARCH_PARAM = 'tab';

export const DEFAULT_VIEW = 'board';
